// extracted by mini-css-extract-plugin
export var container = "video-module--container--f0dcd";